<template>
    <form-wizard
        color="#7367f0"
        :title="null"
        :subtitle="null"
        finish-button-text="Сохранить"
        next-button-text="Далее"
        back-button-text="Назад"
        class="steps-transparent"
        @on-complete="() => submitAction()"
    >
        <tab-content
        icon="feather icon-file-text"
        title="Общие"
        :before-change="()=> validateForm(steps['step_1'].value)"
>
    <validation-observer
            ref="step_1"
            tag="form"
    >
        <b-form-group
            label="Название"
            label-size="sm"
            class="flex-grow-1"
            description="Укажите название"
        >
            <validation-provider
                    #default="{ errors }"
                    name="name"
                    rules="required"
            >
                <b-form-input
                        class="w-100"
                        v-model="formModel['name']"
                        :state="errors.length > 0 ? false:null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
        </b-form-group>

        <b-form-group
            label="Номер"
            label-size="sm"
            class="flex-grow-1"
            description="Укажите номер"
        >
            <validation-provider
                    #default="{ errors }"
                    name="number"
                    rules="required"
            >
                <b-form-input
                        class="w-100"
                        v-model="formModel['number']"
                        :state="errors.length > 0 ? false:null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
        </b-form-group>
    </validation-observer>
</tab-content>
        <tab-content
                icon="feather icon-file-text"
                title="Железная дорога"
                :before-change="()=> validateForm(steps['step_2'].value)"
        >
            <validation-observer
                    ref="step_2"
                    tag="form"
            >
                <b-form-group
                    label="Железная дорога"
                    label-size="sm"
                    class="flex-grow-1"
                    description="Укажите железную дорогу"
                >
                    <validation-provider
                            #default="{ errors }"
                            name="railway"
                            rules="required"
                    >
                        <choose-railway-field
                                v-model="formModel['railway']"
                                @input="val=>formModel['railway']=val"
                        ></choose-railway-field>
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>
            </validation-observer>
        </tab-content>
        <tab-content
                icon="feather icon-file-text"
                title="Пользователь"
                :before-change="()=> validateForm(steps['step_3'].value)"
        >
            <validation-observer
                    ref="step_3"
                    tag="form"
            >
                <b-form-group
                    label="Пользователь"
                    label-size="sm"
                    class="flex-grow-1"
                    description="Укажите пользователя"
                >
                    <validation-provider
                            #default="{ errors }"
                            name="user"
                            rules="required"
                    >
                        <choose-user-field
                                v-model="formModel['user']"
                                @input="val=>formModel['user']=val"
                        ></choose-user-field>
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>
            </validation-observer>
        </tab-content>
    </form-wizard>
</template>


<script>
    import {ref} from '@vue/composition-api'

    import {BContainer, BRow, BCol, BForm, BFormGroup, BFormInput, BFormCheckbox} from 'bootstrap-vue'

    import { FormWizard, TabContent } from 'vue-form-wizard'
    import 'vue-form-wizard/dist/vue-form-wizard.min.css'

    import { STORE_MODULE_NAME } from '@/views/apps/railway_structure/sector/sectorStoreModule'
    import useSector from '@/views/apps/railway_structure/sector/useSector'

    import { validateForm } from '@core/utils/validations/utils'
    import { ValidationProvider, ValidationObserver } from 'vee-validate'
    import { required, email } from '@validations'


    import useAppElementListAddNew from "@core/components/app-elements/appElementListAddNew/useAppElementListAddNew";
    import ChooseUserField from "@/views/apps/user/components/ChooseUserField";
    import ChooseRailwayField from "../../../../../railway/components/ChooseRailwayField";


    export default {

        components:{
            ChooseRailwayField,
            ChooseUserField,
            BContainer, BRow, BCol,
            FormWizard, TabContent,
            BForm, BFormGroup, BFormInput, BFormCheckbox,

            ValidationProvider, ValidationObserver
        },

        setup() {

            const {
                addDataUrl,
                setupData,
            } = useSector();

            const {
                formModel,
                submitAction,
            } = useAppElementListAddNew({
                storeModuleName: STORE_MODULE_NAME,
                addDataUrl: addDataUrl,
                ...setupData,
            })


            const steps = {
                step_1:ref(null),
                step_2:ref(null),
                step_3:ref(null),
            }


            return {
                submitAction,
                formModel,

                steps, ...steps,
                validateForm,
            }
        },
    }
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-wizard.scss';
</style>
